<div class="valio-site-context-selector" *ngIf="(items$ | async)?.length > 1 && (items$ | async) as items">
  <a class="site-context-item"
     *ngFor="let item of items"
     (click)="active = item.isocode; reloadPage()"
     [class.selected]="(activeItem$ | async) === item.isocode"
  >{{ item.isocode }}</a>
</div>
